import { useQuery } from "@tanstack/react-query"
import { getJobs } from "./api/apiCalls"
import BasePrimaryButton from "../../components/general/BasePrimaryButton"
import BasePage from "../../components/layout/BasePage"
import BaseText from "../../components/general/BaseText"
import { useState } from "react"
import ReactMarkdown from "react-markdown"
import { API } from "../../api/api"
import BaseSecondaryHero from "../../components/layout/BaseSecondaryHero"

export default function Jobs() {
    const { data } = useQuery({
        queryKey: ["jobs"],
        queryFn: getJobs,
    })

    return (
        <BasePage>
            <BaseSecondaryHero
                heading={{
                    label: "Join the Team!",
                    headline: "Offene Stellen bei Wicode",
                    text: "Wir sind auf der Suche nach neuen Mitarbeitern, die uns bei der Entwicklung unserer Produkte unterstützen. Wir bieten eine Vielzahl von Stellen, von Frontend-Entwicklern bis hin zu Backend-Entwicklern. Wir sind auch auf der Suche nach neuen Mitarbeitern, die uns bei der Entwicklung unserer Produkte unterstützen. Wir bieten eine Vielzahl von Stellen, von Frontend-Entwicklern bis hin zu Backend-Entwicklern."
                }}
            />
            {/* <BaseSection flexCol paddings="pt-32 pb-16 px-4">
                <BaseHeadline headline="Offene Stellen" />
                <BaseText text="Wir sind auf der Suche nach neuen Mitarbeitern, die uns bei der Entwicklung unserer Produkte unterstützen. Wir bieten eine Vielzahl von Stellen, von Frontend-Entwicklern bis hin zu Backend-Entwicklern. Wir sind auch auf der Suche nach neuen Mitarbeitern, die uns bei der Entwicklung unserer Produkte unterstützen. Wir bieten eine Vielzahl von Stellen, von Frontend-Entwicklern bis hin zu Backend-Entwicklern." />
            </BaseSection> */}
            {data?.map((item: { attributes: JobElementType }) => (
                <JobElement {...item.attributes} />
            ))}
            {/* <ContactCTA /> */}
        </BasePage>
    )
}

type JobElementType = {
    headline: string
    preview?: string
    description: string
    buttonLabel: string
    image: {
        data: {
            attributes: {
                url: string
            }
        }
    }
}

function JobElement(props: JobElementType) {
    const [isOpen, setIsOpen] = useState(false)
    const mailto = (email: string) => {
        window.location.href = `mailto:${email}?subject=Bewerbung für ${props.headline}`
    }
    return (
        <div className={`w-full grid md:grid-cols-12 px-4 max-w-page mb-24 ${isOpen ? "items-start" : "md:items-center"} gap-8`}>
            <img src={API.img + props.image?.data?.attributes?.url} alt={props.headline} className={`md:col-span-4 lg:col-span-3 w-48 h-48 ${isOpen ? "md:w-full md:-72" : "md:h-full md:w-auto"}  aspect-square! object-cover rounded-default`} />
            <div className="w-full flex flex-col md:col-span-8 lg:col-span-9">
                <h3 className={`text-2xl font-bold ${isOpen ? "underline decoration-primary" : ""}`}>{props.headline}</h3>
                <div className="w-full my-2" />
                {isOpen ? (
                    <div className="font-text opacity-100 text-base md:text-lg  markdown-content">
                        <ReactMarkdown>{props.description}</ReactMarkdown>
                    </div>
                ) : (
                    <BaseText text={props.preview!} />
                )}
                <div className="w-full flex justify-end">
                    <BasePrimaryButton text={isOpen ? "Schließen" : props.buttonLabel} onClick={() => setIsOpen(!isOpen)} ghost={isOpen} />
                    {isOpen && <BasePrimaryButton text="Direkt Bewerben" onClick={() => mailto("recruiting@wicode.de")} classProps="ml-4" />}
                </div>
            </div>
        </div>
    )
}
